<template>
    <div class="d-flex flex-column ul-light-gray-panel mb-3 cmptbl-pnl" v-if="compatibleParts != null">
        <div class="d-flex justify-content-between align-items-stretch flex-grow-0 pl-1 ul-light-gray-panel-bottom ul-very-light-background">
            <div>Parts Often Used in Conjunction With {{compatibleParts.partNumber}}</div>
        </div>
        <div class="d-flex flex-column pb-2 pt-2">
            <div class="text-danger" v-for="compatiblePart of compatibleParts.compatibleParts" :key="compatiblePart.partUniqueId">
                <div class="d-flex align-items-center justify-content-center ul-light-gray-panel ul-fat-light-gray-panel m-2 p-1 compatible-part"           
                     v-bind:data-advertiser="compatiblePart.advertiserName" v-bind:data-mfrname="compatiblePart.manufacturerName" v-bind:data-mfrpn="compatiblePart.manufacturerPartNumber">
                    <div class="flex-grow-1 ml-3">
                        {{compatiblePart.manufacturerName}}
                    </div>
                    <div class="flex-grow-1">
                        <router-link class="compatible-part-link internal" @click="compatibleClick" :to="`/${$store.state.instance}/part/p/${compatiblePart.partUniqueId}`">{{compatiblePart.manufacturerPartNumber}}</router-link>
                    </div>
                    <div class="d-flex justify-content-end mr-3" v-if="compatiblePart.hasExternalLink == true">
                        <a @click="compatibleExternal" class="btn btn-light compatible-part-link external" v-bind:class="compatiblePart.advertiserItem.advertiserExternalLinkClass" v-bind:data-advertiser="compatiblePart.advertiserName" v-bind:data-mfrname="compatiblePart.manufacturerName" v-bind:data-mfrpn="compatiblePart.manufacturerPartNumber">
                            <span class="advertiser-compatible-part-link-external-image" v-bind:class="compatiblePart.externalPartLinkCssClass"></span>
                            <span class="advertiser-part-grow-1">{{compatiblePart.ExternalPartLinkText}}</span>
                            <span class="advertiser-compatible-part-link-external-spacer"></span>
                        </a>
                    </div>
                    <div class="d-flex model-availability-listing justify-content-end mr-3">
                        <div v-bind:class="[compatiblePart.hasSymbol ? 'model-availability-symbol-active' : 'model-availability-symbol-inactive']"></div>
                        <div v-bind:class="[compatiblePart.hasFootprint ? 'model-availability-footprint-active' : 'model-availability-footprint-inactive']"></div>
                        <div v-bind:class="[compatiblePart.has3D ? 'model-availability-threed-active' : 'model-availability-threed-inactive']"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CompatiblePartPanel',
        props: {
            compatibleParts: {
                type: Object,
                default: () => {
                    return null
                }
            },
            partContent: {
                type: Object,
                default: () => {
                    return null
                }
            }
        },
        methods: {
            compatibleImpression: function () {
                this.$store.dispatch('gtmCompatiblePart', { sourceMfrName: this.partContent.manufacturer, sourceMfrPN: this.partContent.partNumber, mfrName: this.compatiblePart.manufacturer, mfrPN: this.compatiblePart.partNumber, advertiser: this.compatiblePart.advertiserName });
            },
            compatibleClick: function () {
                this.$store.dispatch('gtmCompatibleInternal', { sourceMfrName: this.partContent.manufacturer, sourceMfrPN: this.partContent.partNumber, mfrName: this.compatiblePart.manufacturer, mfrPN: this.compatiblePart.partNumber, advertiser: this.compatiblePart.advertiserName });
            },
            externalClick: function () {
                this.$store.dispatch('gtmCompatibleExternal', { sourceMfrName: this.partContent.manufacturer, sourceMfrPN: this.partContent.partNumber, mfrName: this.compatiblePart.manufacturer, mfrPN: this.compatiblePart.partNumber, advertiser: this.compatiblePart.advertiserName });
                this.$store.dispatch('openUrl', { url: this.compatiblePart.externalPartLink });
            }
        },
        async mounted() {
            if (this.compatibleParts != null)
                this.compatibleImpression();
        }
    }
</script>

<style scoped>
</style>